import type { ScheduleDateTimePickerPopoverProps } from "@/react/components/PostsCompass/ScheduleDateTimePickerPopover";
import { ScheduleDateTimePickerPopover } from "@/react/components/PostsCompass/ScheduleDateTimePickerPopover";

export interface FooterSchedulePickerProps extends Pick<
  ScheduleDateTimePickerPopoverProps,
  "disabledDays" | "onOpenChange" | "onSave" | "open" | "value"
> {
  anchor: NonNullable<ScheduleDateTimePickerPopoverProps["anchor"]>;
}

export const FooterSchedulePicker = ({
  anchor,
  disabledDays,
  onOpenChange,
  onSave,
  open,
  value,
}: FooterSchedulePickerProps) => (
  <ScheduleDateTimePickerPopover
    anchor={anchor}
    disabledDays={disabledDays}
    onOpenChange={onOpenChange}
    onSave={onSave}
    open={open}
    side="top"
    value={value}
  />
);
